/** Quantos dígitos tem o código do aplicativo autenticador (TOTP, 0085). */
export const QUANTOS_DIGITOS = 6;

/**
 * Só os dígitos do que foi digitado ou colado, até seis: "482 913", "482-913"
 * e "Código: 482913" dão "482913".
 */
export function digitosDoCodigo(texto: string): string {
  return texto.replace(/\D/g, '').slice(0, QUANTOS_DIGITOS);
}

/** O código está inteiro (os seis campos cheios)? */
export function codigoCompleto(valor: string): boolean {
  return /^\d{6}$/.test(valor);
}
